import React, { useContext, useRef, useCallback } from "react";
import PropTypes from "prop-types";

import TooltipWrap from "./TooltipWrap";

export const TooltipContext = React.createContext({});

export const TooltipProvider = ({ children }) => {
  const rootRef = useRef(null);

  const showTooltip = useCallback((...args) => {
    if (rootRef?.current) {
      rootRef.current.show(...args);
    }
  }, []);

  const hideTooltip = useCallback(() => {
    if (rootRef?.current) {
      rootRef.current.hide();
    }
  },[]);

  return (
    <TooltipContext.Provider value={{ showTooltip, hideTooltip }}>
      <TooltipWrap ref={rootRef} />
      {children}
    </TooltipContext.Provider>
  );
};

TooltipProvider.propTypes = {
  children: PropTypes.node
};

/**
 * @returns {{
 *   showTooltip, hideTooltip,
 * }}
 */
export const useTooltipContext = () => useContext(TooltipContext);
